import getTypographyStyle from '../getTypographyStyle';

const baseText = {
  typography: {
    displaySemiBold: getTypographyStyle(32, 'semibold', 'display'),
    displayBold: getTypographyStyle(32, 'bold', 'display'),

    h1Bold: getTypographyStyle(24, 'bold', 'h1'),
    h1Semibold: getTypographyStyle(24, 'semibold', 'h1'),

    h2Bold: getTypographyStyle(20, 'bold', 'h2'),
    h2Semibold: getTypographyStyle(20, 'semibold', 'h2'),

    h3Bold: getTypographyStyle(18, 'bold', 'h3'),
    h3Semibold: getTypographyStyle(18, 'semibold', 'h3'),

    subRegular: getTypographyStyle(14, 'regular', 'sub'),
  },
  paragraph: {
    p1Bold: getTypographyStyle(16, 'bold', 'p1'),
    p1Semibold: getTypographyStyle(16, 'semibold', 'p1'),
    p1Medium: getTypographyStyle(16, 'medium', 'p1'),
    p1Regular: getTypographyStyle(16, 'regular', 'p1'),

    p2Bold: getTypographyStyle(15, 'bold', 'p2'),
    p2Semibold: getTypographyStyle(15, 'semibold', 'p2'),
    p2Medium: getTypographyStyle(15, 'medium', 'p2'),
    p2Regular: getTypographyStyle(15, 'regular', 'p2'),

    p3Bold: getTypographyStyle(14, 'bold', 'p3'),
    p3Semibold: getTypographyStyle(14, 'semibold', 'p3'),
    p3Medium: getTypographyStyle(14, 'medium', 'p3'),
    p3Regular: getTypographyStyle(14, 'regular', 'p3'),

    p4Bold: getTypographyStyle(13, 'bold', 'p4'),
    p4Semibold: getTypographyStyle(13, 'semibold', 'p4'),
    p4Medium: getTypographyStyle(13, 'medium', 'p4'),
    p4Regular: getTypographyStyle(13, 'regular', 'p4'),
  },
  caption: {
    captionSemibold: getTypographyStyle(12, 'semibold', 'caption'),
    captionMedium: getTypographyStyle(12, 'medium', 'caption'),
    captionRegular: getTypographyStyle(12, 'regular', 'caption'),
  },
};

const text = {
  ...baseText,

  buttonNormal: baseText.paragraph.p2Semibold,
  buttonSmall: baseText.paragraph.p3Semibold,
  buttonSub: baseText.paragraph.p3Semibold,

  digitInputNormal: baseText.typography.h2Semibold,
  digitInputLabelNormal: baseText.paragraph.p3Regular,

  keypadKeys: {
    fontSize: 24,
    fontWeight: 500,
  },
  keypadDesc: {
    fontSize: 14,
    fontWeight: 400,
    color: 'rgba(111, 119, 138, 1)',
  },
  keypadDescWarning: {
    fontSize: 14,
    fontWeight: 400,
    color: 'rgba(227, 62, 56, 1)',
  },
};

export default text;
